import wx from 'weixin-js-sdk'

import getWXSign from './getWXSign';

export default {
    wxMenuHide(){
        getWXSign().then(() => {
            wx.hideMenuItems({
                menuList:[
                    'menuItem:share:appMessage',
                    'menuItem:share:timeline',
                    'menuItem:share:qq',
                    'menuItem:share:weiboApp"',
                    '"menuItem:favorite',
                    'menuItem:share:facebook',
                    'menuItem:share:QZone',
                    'menuItem:editTag',
                    'menuItem:delete',
                    'menuItem:copyUrl',
                    'menuItem:originPage',
                    'menuItem:readMode',
                    'menuItem:openWithQQBrowser',
                    'menuItem:openWithSafari',
                    'menuItem:share:email',
                    'menuItem:share:brand',
                ]
            })
        })
    }
}

